var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 35,
    viewBox: "0 0 26 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6107 7.53367C12.2389 5.5832 10.9874 3.10653 10.0902 0.863116C9.92922 0.457262 9.35617 0.452627 9.18106 0.858008C8.22129 3.09385 6.90245 5.55464 5.4753 7.49004C5.19188 7.87661 5.57924 8.38848 6.03294 8.2283L8.25937 7.44507C8.2849 10.4285 8.19025 13.4174 7.88894 16.3945C7.71746 18.1026 7.47791 19.8101 7.14853 21.5012C6.82252 23.1915 6.39659 24.868 5.84058 26.5098C5.81667 26.5867 5.84818 26.6709 5.92448 26.7048C6.00497 26.7413 6.10009 26.7067 6.13746 26.6265C6.88562 25.039 7.51223 23.3935 8.04235 21.7192C8.57584 20.044 9.0162 18.3391 9.39193 16.6186C10.0539 13.5968 10.5061 10.5358 10.8331 7.46011L13.034 8.26679C13.4819 8.43044 13.8852 7.92159 13.6107 7.53367Z",
    fill: "url(#paint0_linear_1494_9840)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.953 16.0754C20.6651 14.1038 19.4738 11.612 18.6089 9.36047C18.4536 8.95318 17.9344 8.935 17.7852 9.33386C16.9678 11.5339 15.8304 13.9491 14.5826 15.8393C14.3349 16.2169 14.6976 16.735 15.1049 16.5865L17.1035 15.8606C17.196 18.8272 17.1798 21.7963 16.9761 24.7488C16.8604 26.4429 16.6831 28.1347 16.4241 29.8082C16.1681 31.4809 15.8212 33.1374 15.3558 34.7565C15.3359 34.8324 15.3664 34.9168 15.4363 34.9524C15.51 34.9905 15.5954 34.9584 15.6274 34.8795C16.2682 33.319 16.7976 31.698 17.2388 30.046C17.6831 28.3933 18.0424 26.7088 18.3427 25.0073C18.8722 22.0189 19.2105 18.9864 19.4352 15.9365L21.4477 16.7906C21.8572 16.9639 22.2107 16.4675 21.953 16.0754Z",
    fill: "url(#paint1_linear_1494_9840)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1494_9840",
    x1: 10.3328,
    y1: 0.365668,
    x2: -1.38575,
    y2: 14.4483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1494_9840",
    x1: 18.9689,
    y1: 8.83349,
    x2: 8.53038,
    y2: 20.3067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2A6A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.fd8ce0e387ae1cfe8dc6a5f2c91343db.svg";
export { ForwardRef as ReactComponent };